import React from 'react';
import GallerySlider from '../components/GallerySlider'; 
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import ContactForm from '../components/ContactForm'; 
import FloatingSocial from '../components/floating_social'; 

const Contact = () => {
  return (
    <div>
      <Header />
  
	<div class="section big-55-height over-hide z-bigger">
	
		<div class="parallax parallax-top" style={{ backgroundImage: `url('/img/22.jpeg')` }}></div>
		<div class="dark-over-pages"></div>
	
		<div class="hero-center-section pages">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12 parallax-fade-top">
						<div class="hero-text">Get in Touch</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div class="contact-section section-padding fix">
        <div class="container">
            <div class="row gy-5 gx-60">
                <div class="col-xl-6">
                    <div class="contact-form style1 img-custom-anim-left wow fadeInUp" data-wow-delay=".4s">
                        <div class="section-title mb-3">
                            <div class="subtitle wow fadeInUp" data-wow-delay=".5s"> Contact Us </div>
                            <h2 class="mt-15 wow fadeInUp" data-wow-delay=".3s"> Get In Touch </h2>
                        </div>
                         <ContactForm />
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contact-content style1 wow fadeInUp" data-wow-delay=".4s">
                        <div class="shape1"><img src="img/contactShape1_1.png" alt="shape"/></div>
                        <div class="section-title">
                            <h2 class="mt-15 wow fadeInUp" data-wow-delay=".3s"> Contact Info </h2>
                            <p>Cloud computing is a model for delivering on-demand the computing resources over the
                                internet.</p>
                        </div>
                         <div class="fancy-box style1">
                                <div class="fancy-item">
                                    <div class="icon2">
                                        <img src="img/phoneIcon.svg" alt="icon"/>
                                    </div>
                                </div>
                                <div class="fancy-item">
                                    <h4 class=" text-start">Phone/Whatsapp</h4>
                                    <p class="text-start">+91 9692908503, +91 9692908506, +91 9692908502, +91 9692908504</p>
                                </div>
                            </div>
						 <div class="fancy-box style1">
                                <div class="fancy-item">
                                    <div class="icon2">
                                        <img src="img/emailIcon.svg" alt="icon"/>
                                    </div>
                                </div>
                                <div class="fancy-item">
                                    <h4 class="text-start">Email</h4>
                                    <p class="text-start">reservations@hotelpahadi.com</p>
                                </div>
                            </div>

                        <div class="fancy-box style1">
                            <div class="fancy-item">
                                <div class="icon2">
                                    <img src="img/locationIcon.svg" alt="icon"/>
                                </div>
                            </div>
                            <div class="fancy-item">
                                <h4 class="text-start">Location</h4>
                                <p class="text-start">Hotel Pahadi, Vedvyas, Rourkela, Odisha, India</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3693.0845643122248!2d84.7701451752907!3d22.236870056125767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2017d3b8917467%3A0x6091ff621ae0772f!2sHotel%20Pahadi!5e0!3m2!1sen!2sin!4v1763540279762!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>


    <br />
	
	 <GallerySlider />
	<br></br>
        <Footer />
        <FloatingSocial />
    </div>
  )
}

export default Contact;